import React from "react";
import PropTypes from "prop-types";
import {
  faUser,
  faMobile,
  faEnvelope
} from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";

const Customer = props => {
  const { customer, align } = props;
  const email = customer.user ? customer.user.email : customer.email;

  return (
    <div className={`text-${align} break-word`}>
      <label>
        {customer.user ? customer.user.first_name : customer.first_name}{" "}
        {customer.user ? customer.user.last_name : customer.last_name}{" "}
        <FontAwesomeIcon icon={faUser} />{" "}
      </label>

      {email && (
        <div>
          <a className="break-word" href={`mailto:${email}`}>
            {email} <FontAwesomeIcon icon={faEnvelope} />
          </a>{" "}
        </div>
      )}
      {customer.phone_number && (
        <div>
          <a className="break-word" href={`tel:${customer.phone_number}`}>
            {customer.phone_number} <FontAwesomeIcon icon={faMobile} />
          </a>{" "}
        </div>
      )}
    </div>
  );
};

Customer.propTypes = {
  customer: PropTypes.object.isRequired,
  align: PropTypes.string
};

Customer.defaultProps = {
  align: "left"
};

export default Customer;
